import { AccountDetails } from 'clientServerShared/types/account';
import { buildMyEvLegacyLink } from 'projects/sharedComponents/src/services/links/linkBuilder';
import { trackClick } from 'projects/sharedComponents/src/services/evtrk/evtrk';

type HeaderLinksProps = {
  chatBubbleSrc: string;
  chatBubbleAriaLabel: string;
  accountDetails: AccountDetails;
};

export const HeaderLinks: React.FC<HeaderLinksProps> = (props) => {
  const { chatBubbleSrc, chatBubbleAriaLabel, accountDetails } = props;

  const numUnreadMessages = accountDetails.user?.numUnreadMessages ?? 0;

  const eventCategory = accountDetails.user?.permissions.isBreeder
    ? 'My Embark Breeder Page'
    : accountDetails.user?.permissions.isVet
    ? 'My Embark Vet Page'
    : 'My Embark Page';

  return (
    <ul className="desktopHeader-menu">
      <li>
        <a
          href={buildMyEvLegacyLink('/members/messages')}
          className="desktopHeader-chatLink"
          onClick={() => trackClick({ eventAction: 'Chat', eventCategory })}
          aria-label={chatBubbleAriaLabel}
        >
          <img src={chatBubbleSrc} alt="" />
          {numUnreadMessages > 0 && (
            <span className="header-chatBubble" data-testid="header-chatBubble">
              {numUnreadMessages}
            </span>
          )}
        </a>
      </li>
      <li>
        <a href={buildMyEvLegacyLink('/members/profile')}>Settings</a>
      </li>
      <li>
        <a href={buildMyEvLegacyLink('/logout')}>Sign Out</a>
      </li>
    </ul>
  );
};
